import { BrowserRouter, Routes, Route } from 'react-router';
import { AppShell } from './components/layout/AppShell';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { LoginCallback } from './components/auth/LoginCallback';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { OnboardingWizard } from './pages/onboarding/OnboardingWizard';
import { NotFound } from './pages/NotFound';
import { FrameworkList } from './pages/frameworks/FrameworkList';
import { FrameworkDetail } from './pages/frameworks/FrameworkDetail';
import { AssessmentOverview } from './pages/assessments/AssessmentOverview';
import { AssessmentWizard } from './pages/assessments/AssessmentWizard';
import { DeliverableList } from './pages/deliverables/DeliverableList';
import { DeliverableDetail } from './pages/deliverables/DeliverableDetail';
import { TeamList } from './pages/team/TeamList';
import { FileList } from './pages/files/FileList';
import { SnapshotList } from './pages/snapshots/SnapshotList';
import { AuditorLinkList } from './pages/auditor-links/AuditorLinkList';
import { AuditorView } from './pages/auditor/AuditorView';
import { Settings } from './pages/Settings';
import { TenantManagement } from './pages/admin/TenantManagement';
import { LeadPipeline } from './pages/admin/LeadPipeline';
import { PlatformMetrics } from './pages/admin/PlatformMetrics';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<LoginCallback />} />

        {/* Public auditor view */}
        <Route path="/auditor/:token" element={<AuditorView />} />

        {/* Onboarding (authenticated, no shell) */}
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <OnboardingWizard />
            </ProtectedRoute>
          }
        />

        {/* Protected routes with shell */}
        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="frameworks" element={<FrameworkList />} />
          <Route path="frameworks/:frameworkId" element={<FrameworkDetail />} />
          <Route path="assessments" element={<AssessmentOverview />} />
          <Route path="assessments/:frameworkId" element={<AssessmentWizard />} />
          <Route path="deliverables" element={<DeliverableList />} />
          <Route path="deliverables/:deliverableId" element={<DeliverableDetail />} />
          <Route path="team" element={<TeamList />} />
          <Route path="files" element={<FileList />} />
          <Route path="snapshots" element={<SnapshotList />} />
          <Route path="auditor-links" element={<AuditorLinkList />} />
          <Route path="settings" element={<Settings />} />

          {/* Admin */}
          <Route path="admin/tenants" element={<TenantManagement />} />
          <Route path="admin/leads" element={<LeadPipeline />} />
          <Route path="admin/metrics" element={<PlatformMetrics />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
